import moduleName from './main.module';
import './_services/booking_calendar.service.js';
import './_translations/en.js';
import './accordion-group/bb_accordion_group.directive.js';
import './accordion-range-group/bb_accordian_range_group.controller.js';
import './accordion-range-group/bb_accordion_range_group.directive.js';
import './accordion-range-group/v2/time_range_accordion_group.component.js';
import './attendee/bb_attendees.directive.js';
import './basket-list/bb_basket_list.controller.js';
import './basket-list/bb_basket_list.directive.js';
import './basket-summary/bb_basket_summary.controller.js';
import './basket-summary/bb_basket_summary.directive.js';
import './basket/bb_basket.directive.js';
import './breadcrumb/bb_breadcrumb.controller.js';
import './breadcrumb/bb_breadcrumb.directive.js';
import './bulk-purchases/bb_bulk_purchases.controller.js';
import './bulk-purchases/bb_bulk_purchases.directive.js';
import './categories/bb_categories.controller.js';
import './categories/bb_categories.directive.js';
import './checkout/bb_checkout.controller.js';
import './checkout/bb_checkout.directive.js';
import './client-details/bb_client_details.controller.js';
import './client-details/bb_client_details.directive.js';
import './companies/bb_companies.directive.js';
import './company-details/company_details.component.js';
import './content-new/bb_content_new.directive.js';
import './custom-booking-text/bb_custom_booking_text.controller.js';
import './custom-booking-text/bb_custom_booking_text.directive.js';
import './custom-confirmation-text/bb_custom_confirmation_text.controller.js';
import './custom-confirmation-text/bb_custom_confirmation_text.directive.js';
import './day-list/bb_day_list.controller.js';
import './day-list/bb_day_list.directive.js';
import './deals/bb_deals.controller.js';
import './deals/bb_deals.directive.js';
import './durations/bb_durations.controller.js';
import './durations/bb_durations.directive.js';
import './email-confirmation-checkbox/bb_email_confirmation_checkbox.component.js';
import './email-confirmation-checkbox/bb_email_confirmation_options.provider.js';
import './email-confirmation-checkbox/bb_email_confirmation.service.js';
import './entry.module.js';
import './event-groups/bb_event_groups.controller.js';
import './event-groups/bb_event_groups.directive.js';
import './event/bb_event.controller.js';
import './event/bb_event.directive.js';
import './events/bb_events.controller.js';
import './events/bb_events.directive.js';
import './globs_to_remove.js';
import './items-details/bb_items_details.controller.js';
import './items-details/bb_items_details.directive.js';
import './loader/bb_loader.directive.js';
import './loader/v2/loader.service.js';
import './main.module.js';
import './main.vendors.js';
import './map/map.component.js';
import './map/map.controller.js';
import './mini-basket/bb_mini_basket.directive.js';
import './minspend/bb_minspend.directive.js';
import './month-calendar/bb_month_calendar.controller.js';
import './month-calendar/bb_month_calendar.directive.js';
import './month-picker-listener/bb_month_picker_listener.directive.js';
import './month-picker/bb_month_picker.directive.js';
import './move-booking-modal-button/bb_move_booking_modal_button.component.js';
import './move-booking/bb_move_booking.component.js';
import './move-booking/move_booking_options.provider.js';
import './multiservice-select/bb_multiservice_select.controller.js';
import './multiservice-select/bb_multiservice_select.directive.js';
import './package-items/bb_package_items.controller.js';
import './package-items/bb_package_items.directive.js';
import './package-picker/bb_package_picker.controller.js';
import './package-picker/bb_package_picker.directive.js';
import './page/bb_page.controller.js';
import './page/bb_page.directive.js';
import './pagination/pagination.component.js';
import './pay-form/bb_pay_form.controller.js';
import './pay-form/bb_pay_form.directive.js';
import './payment-button/bb_payment_button.directive.js';
import './payment/bb_payment.controller.js';
import './payment/bb_payment.directive.js';
import './paypal-buttons/bb_paypal_express_button.directive.js';
import './paypal-buttons/bb_paypal.directive.js';
import './people/bb_people.controller.js';
import './people/bb_people.directive.js';
import './product-list/bb_product_list.controller.js';
import './product-list/bb_product_list.directive.js';
import './purchase-total/bb_purchase_total.controller.js';
import './purchase-total/bb_purchase_total.directive.js';
import './purchase/_models/purchase_booking_model.service.js';
import './purchase/_models/purchase_course_booking_model.service.js';
import './purchase/_models/purchase_total_model.service.js';
import './purchase/_services/purchase_booking.service.js';
import './purchase/_services/purchase.service.js';
import './purchase/purchase.directive.js';
import './resources/bb_resources.controller.js';
import './resources/bb_resources.directive.js';
import './services/bb_services.controller.js';
import './services/bb_services.directive.js';
import './skip-decide-next-page/bb_skip_decide_next_page.directive.js';
import './spaces/bb_spaces.controller.js';
import './spaces/bb_spaces.directive.js';
import './step-navigation/step-navigation.component.js';
import './step-navigation/step-navigation.module.js';
import './summary/bb_summary.controller.js';
import './summary/bb_summary.directive.js';
import './survey-questions/bb_survey_questions.controller.js';
import './survey-questions/bb_survey_questions.directive.js';
import './time-range-stacked/bb_time_range_stacked.controller.js';
import './time-range-stacked/bb_time_range_stacked.directive.js';
import './time-ranges/accessible-grid/accessible_calendar_grid_escape.directive.js';
import './time-ranges/accessible-grid/accessible_calendar_grid.directive.js';
import './time-ranges/bb_accessible_grid.directive.js';
import './time-ranges/bb_time_ranges.controller.js';
import './time-ranges/bb_time_ranges.directive.js';
import './time-ranges/v2/time_ranges.controller.js';
import './time-ranges/v2/time_ranges.directive.js';
import './time-slots/bb_time_slots.controller.js';
import './time-slots/bb_time_slots.directive.js';
import './times/bb_times.controller.js';
import './times/bb_times.directive.js';
import './total/bb_total.controller.js';
import './total/bb_total.directive.js';
import './widget-modal/bb_widget_modal.directive.js';
import './widget-modal/bb_widget_modal.service.js';
import './widget/bb_widget_basket.service.js';
import './widget/bb_widget_init.service.js';
import './widget/bb_widget_page.service.js';
import './widget/bb_widget_routes.service.js';
import './widget/bb_widget_step.service.js';
import './widget/bb_widget_utilities.service.js';
import './widget/bb_widget.controller.js';
import './widget/bb_widget.directive.js';
import './widget/bb_widget.service.js';
export default moduleName;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/entry.module.js